module.exports = __webpack_public_path__ + "img/putin.931166b4.webp";